import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getShowComplaints = store => store[NAME].showComplaints;
export const getLoadingHome = store => store[NAME].isLoadingHome;
export const getIndicators = store => store[NAME].indicators;
export const getClassificationList = store => store[NAME].classificationList;